import { db } from '../config/firebase';
import { 
  collection, 
  doc, 
  setDoc, 
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  where,
  serverTimestamp 
} from 'firebase/firestore';

/**
 * Get all services for a caregiver
 */
export const getCaregiverServices = async (caregiverId) => {
  try {
    const servicesQuery = query(
      collection(db, 'services'),
      where('caregiverId', '==', caregiverId)
    );
    
    const snapshot = await getDocs(servicesQuery);
    const services = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    return {
      success: true,
      services
    };
  } catch (error) {
    console.error('Get caregiver services error:', error);
    return {
      success: false,
      error: error.message,
      services: []
    };
  }
};

/**
 * Add a new service for a caregiver
 */
export const addService = async (caregiverId, serviceData) => {
  try {
    const serviceRef = doc(collection(db, 'services'));
    const newService = {
      ...serviceData,
      caregiverId,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    await setDoc(serviceRef, newService);
    
    return {
      success: true,
      serviceId: serviceRef.id,
      service: {
        id: serviceRef.id,
        ...newService
      }
    };
  } catch (error) {
    console.error('Add service error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Update an existing service
 */
export const updateService = async (serviceId, updates) => {
  try {
    const serviceRef = doc(db, 'services', serviceId);
    await updateDoc(serviceRef, {
      ...updates,
      updatedAt: serverTimestamp()
    });
    
    return {
      success: true
    };
  } catch (error) {
    console.error('Update service error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Delete a service
 */
export const deleteService = async (serviceId) => {
  try {
    await deleteDoc(doc(db, 'services', serviceId));
    
    return {
      success: true
    };
  } catch (error) {
    console.error('Delete service error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Toggle service availability
 */
export const toggleServiceAvailability = async (serviceId, isAvailable) => {
  try {
    await updateDoc(doc(db, 'services', serviceId), {
      available: isAvailable,
      updatedAt: serverTimestamp()
    });
    
    return {
      success: true
    };
  } catch (error) {
    console.error('Toggle service availability error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

